import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var DcmSvg = function DcmSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.333 2H3.667C2.747 2 2 2.746 2 3.667v16.666C2 21.253 2.746 22 3.667 22h16.666c.92 0 1.667-.746 1.667-1.667V3.667C22 2.747 21.254 2 20.333 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.376 14.5c1.957 0 2.868-1.005 2.868-2.741 0-1.665-.832-2.637-2.812-2.674L4.99 9.08h-.247l-.24-.002h-.53V14.5zm.015-.754h-.492V9.831h.514c1.17 0 1.875.525 1.875 1.931 0 1.455-.784 1.984-1.897 1.984m6.003.829c1.422 0 2.014-.889 2.138-1.875h-.964c-.109.6-.514 1.11-1.2 1.11-.862 0-1.354-.619-1.354-2.044 0-1.414.492-1.999 1.354-1.999.686 0 1.091.454 1.2 1.05h.964c-.105-1.012-.953-1.815-2.138-1.815-1.5 0-2.388 1.02-2.388 2.753 0 1.736.896 2.82 2.388 2.82m4.1-.075v-4.226L16.91 14.5h.76l1.43-4.253V14.5h.926V9.077h-1.298l-1.436 4.144-1.421-4.144h-1.305V14.5z"
  }));
};
export var Dcm = function Dcm(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: DcmSvg
  }));
};